export default (function (_ref) {
  var request = _ref.request;
  return {
    breedFormulaAdd: function breedFormulaAdd(data) {
      return request({
        url: '/cms/breedFormula/add',
        method: 'post',
        data: data
      });
    },
    breedFormulaModify: function breedFormulaModify(data) {
      return request({
        url: "/cms/breedFormula/".concat(data.id, "/modify"),
        method: 'put',
        data: data
      });
    },
    breedFormulaDel: function breedFormulaDel(id) {
      return request({
        url: "/cms/breedFormula/".concat(id, "/del"),
        method: 'delete'
      });
    },
    breedFormulaQuery: function breedFormulaQuery(data) {
      return request({
        url: '/cms/breedFormula',
        method: 'get',
        params: data
      });
    },
    breedFormulaDetail: function breedFormulaDetail(id) {
      return request({
        url: "/cms/breedFormula/".concat(id),
        method: 'get'
      });
    }
  };
});